module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fillProfileOpen) ? _c('div', {
    staticClass: "fpr__bg",
    on: {
      "click": _vm.closeFillProfile
    }
  }, [_c('div', {
    staticClass: "fpr__modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "fpr__top"
  }, [_c('img', {
    staticClass: "fpr__close",
    attrs: {
      "src": "/static/img/ic_close.svg"
    },
    on: {
      "click": _vm.closeFillProfile
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "fpr__ill",
    attrs: {
      "src": "/static/img/note.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fpr__reward"
  }, [_vm._v("+10")]), _vm._v(" "), _c('p', {
    staticClass: "fpr__heading"
  }, [_vm._v("Давай знакомиться ближе!")]), _vm._v(" "), _c('p', {
    staticClass: "fpr__desc"
  }, [_vm._v("Заполни анкету и получи 10 баллов!")]), _vm._v(" "), _c('div', {
    staticClass: "fpr__button",
    on: {
      "click": _vm.onButtonClicked
    }
  }, [_vm._v("Заполнить анкету")])]), _vm._v(" "), _c('div', {
    staticClass: "fpr__bottom"
  }, [_vm._v("*Обязательно для перехода на 3-й уровень")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cb38fce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/fill-profile.vue
// module id = 305
// module chunks = 1